import axios from "axios";
import { Auth_URL, Auth_URL2, Partner_Service_URL } from "../Url";
import HashMap from "hashmap";
import { clearLogoutData } from "../logout/action";

var map = new HashMap();
var err;
function objToStrMap(obj) {
  let strMap = new Map();
  for (let k of Object.keys(obj)) {
    strMap.set(k, obj[k]);
  }
  return strMap;
}

export const EngagementDetailMasterActions = {
  ENGAGEMENT_DETAILS_MASTER_SUCCESS: "ENGAGEMENT_DETAILS_MASTER_SUCCESS",
  ENGAGEMENT_DETAIL_MASTER_ERROR: "ENGAGEMENT_DETAIL_MASTER_ERROR",
};

export function EngagementDetailMaster(props) {
  const accessToken = props;

  return (dispatch) =>
    axios({
      method: "post",
      url: `${Partner_Service_URL}/get/partnerEngagementDetailsMasters`,
      headers: {
        authorization: "Bearer " + accessToken,
      },
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(EngagementDetailMasterSuccess(response.data));
          // dispatch(setLogoutFlag());
          return response;
        } else if (response.status === 401) {
          // return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(EngagementDetailMasterError(error));

          // return response;
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

          map.forEach((ele) => (err = ele));

          return err;
        }
      });
}

export function EngagementDetailMasterError(error) {
  return {
    type: EngagementDetailMasterActions.ENGAGEMENT_DETAIL_MASTER_ERROR,
    payload: error,
  };
}

export function EngagementDetailMasterSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: EngagementDetailMasterActions.ENGAGEMENT_DETAILS_MASTER_SUCCESS,
      payload: props,
    });
  };
}

export const EngagementTypeActions = {
  ENGAGEMENT_TYPE_SUCCESS: "ENGAGEMENT_TYPE_SUCCESS",
  ENGAGEMENT_TYPE_ERROR: "ENGAGEMENT_TYPE_ERROR",
};

export function PartnerEngagementTypes(accesToken, firmId) {
  return (dispatch) =>
    axios({
      method: "post",
      url: `${Partner_Service_URL}/getPartnerEngagementTypeByPartnerFirmId?partnerFirmId=${firmId}`,
      headers: {
        authorization: "Bearer " + accesToken,
      },
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(EngagementTypeSuccess(response.data.dtoList));
          // dispatch(setLogoutFlag());
          return response;
        } else if (response.status === 401) {
          // return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(EngagementTypeError(error));

          // return response;
          throw error;
        }
      })
      .catch((err) => {
        dispatch(EngagementTypeError(err));
        if (err.response) {
          map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

          map.forEach((ele) => (err = ele));

          return err;
        } else if (!err.response) {
        }
      });
}

export function EngagementTypeError(error) {
  return {
    type: EngagementTypeActions.ENGAGEMENT_TYPE_ERROR,
    payload: error,
  };
}

export function EngagementTypeSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: EngagementTypeActions.ENGAGEMENT_TYPE_SUCCESS,
      payload: props,
    });
  };
}

export const EngagementRoleActions = {
  ENGAGEMENT_ROLE_SUCCESS: "ENGAGEMENT_ROLE_SUCCESS",
  ENGAGEMENT_ROLE_ERROR: "ENGAGEMENT_ROLE_ERROR",
};

export function PartnerRoleTypes(accessToken, firmId) {
  return (dispatch) =>
    axios({
      method: "post",
      url: `${Partner_Service_URL}/getPartnerEngagementRoleByPartnerFirmId?partnerFirmId=${firmId}`,
      headers: {
        authorization: "Bearer " + accessToken,
      },
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(EngagementRoleSuccess(response.data.dtoList));
          // dispatch(setLogoutFlag());
          return response;
        } else if (response.status === 401) {
          // return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(EngagementRoleError(error));

          // return response;
          throw error;
        }
      })
      .catch((err) => {
        dispatch(EngagementRoleError(err));
        if (err.response) {
          map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

          map.forEach((ele) => (err = ele));

          return err;
        } else if (!err.response) {
        }
      });
}

export function EngagementRoleError(error) {
  return {
    type: EngagementRoleActions.ENGAGEMENT_ROLE_ERROR,
    payload: error,
  };
}

export function EngagementRoleSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: EngagementRoleActions.ENGAGEMENT_ROLE_SUCCESS,
      payload: props,
    });
  };
}

export const EngagementProductActions = {
  ENGAGEMENT_PRODUCT_SUCCESS: "ENGAGEMENT_PRODUCT_SUCCESS",
  ENGAGEMENT_PRODUCT_ERROR: "ENGAGEMENT_PRODUCT_ERROR",
};

export function PartnerProductTypes(accessToken, firmId) {
  return (dispatch) =>
    axios({
      method: "post",
      url: `${Partner_Service_URL}/getPartnerEngagementProductByPartnerFirmId?partnerFirmId=${firmId}`,
      headers: {
        authorization: "Bearer " + accessToken,
      },
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(EngagementProductSuccess(response.data.dtoList));
          // dispatch(setLogoutFlag());
          return response;
        } else if (response.status === 401) {
          // return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(EngagementProductError(error));

          // return response;
          throw error;
        }
      })
      .catch((err) => {
        dispatch(EngagementProductError(err));
        if (err.response) {
          map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

          map.forEach((ele) => (err = ele));

          return err;
        } else if (!err.response) {
        }
      });
}

export function EngagementProductError(error) {
  return {
    type: EngagementProductActions.ENGAGEMENT_PRODUCT_ERROR,
    payload: error,
  };
}

export function EngagementProductSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: EngagementProductActions.ENGAGEMENT_PRODUCT_SUCCESS,
      payload: props,
    });
  };
}

export const saveAllEngagementDetailsActions = {
  SAVE_ALL_ENGAGEMENT_DETAILS_LOADING: "SAVE_ALL_ENGAGEMENT_DETAILS_LOADING",
  SAVE_ALL_ENGAGEMENT_DETAILS_SUCCESS: "SAVE_ALL_ENGAGEMENT_DETAILS_SUCCESS",
  SAVE_ALL_ENGAGEMENT_DETAILS_ERROR: "SAVE_ALL_ENGAGEMENT_DETAILS_ERROR",
};

export const saveAllEngagementDetails =
  (props) => async (dispatch, getState) => {
    const accessToken = props.accessToken ?? getState()?.auth?.idToken;

    const { data, partnerFirmId } = props;

    dispatch(saveAllEngagementDetailsLoading());
    return axios({
      method: "post",
      url: `${Partner_Service_URL}/saveAllEngagementDetails`,
      headers: {
        authorization: "Bearer " + accessToken,
      },
      data,
      params: {
        partnerFirmId,
      },
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(saveAllEngagementDetailsSuccess(response.data));
          return response;
        } else if (response.status === 401) {
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(saveAllEngagementDetailsError(error));

          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(saveAllEngagementDetailsError(err));
          return err.response;
        }
      });
  };

export function saveAllEngagementDetailsError(error) {
  return {
    type: saveAllEngagementDetailsActions.SAVE_ALL_ENGAGEMENT_DETAILS_ERROR,
    payload: error,
  };
}

export function saveAllEngagementDetailsSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: saveAllEngagementDetailsActions.SAVE_ALL_ENGAGEMENT_DETAILS_SUCCESS,
      payload: props,
    });
  };
}

export function saveAllEngagementDetailsLoading() {
  return {
    type: saveAllEngagementDetailsActions.SAVE_ALL_ENGAGEMENT_DETAILS_LOADING,
  };
}
